<template>
    <tr v-if="collapseActive" class="dashboard__list_enrolments_table_item_collapse_table">
        <td class="dashboard__list_enrolments_table_item_collapse_table_wrapper" colspan="6">
            <table>
                <list-table-head :labels="[$t('dashboard.labels.date'), $t('dashboard.labels.time'), $t('dashboard.labels.trainers'), $t('dashboard.labels.location'), '']"/>
                <tbody>
                <template
                    v-for="(item, index) in items"
                >
                    <dashboard-list-enrolments-table-item-collapse-table-item
                        :item="item"
                        :key="`dashboard-list-enrolments-table-item-collapse-table-item-${index}`"
                    />
                </template>
                </tbody>
            </table>
        </td>
    </tr>
</template>

<script>
import ListTableHead from '@/components/default/shared/ListTableHead'
import DashboardListEnrolmentsTableItemCollapseTableItem from '@/components/dashboard/list/enrolments/DashboardListEnrolmentsTableItemCollapseTableItem'
export default {
  name: 'dashboard-list-enrolments-table-item-collapse-table',
  components: { DashboardListEnrolmentsTableItemCollapseTableItem, ListTableHead },
  props: {
    item: {
      type: Object,
      required: true
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    items () {
      return this.item.modules
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/_dashboardlisttableitemcollapse.scss";
</style>
